var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar-menu pt-10"},[_c('div',{staticClass:"sidebar-menu__nav"},[_c('SidebarMenuNav',{attrs:{"menu":_vm.menu},on:{"updateCurrent":function($event){_vm.current = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }